// Configuration for allowed transfer types and their display labels

export const ALLOWED_TRANSFER_TYPES = [
  "dtf transfers by size",
  "procolor",
  "uv dtf stickers by size",
  "glitter dtf transfers by size"
];

export const TRANSFER_TYPE_SHORT_LABELS: Record<string, string> = {
  "dtf transfers by size": "Standard",
  procolor: "ProColor",
  "uv dtf stickers by size": "UV DTF",
  "glitter dtf transfers by size": "Glitter"
};

export const DEFAULT_TRANSFER_TYPE_NAME = "dtf transfers by size";
